import { InlineAlert, InlineAlertBody, InlineAlertPrimaryButton, InlineAlertTitle } from '@/components/ui/InlineAlert';
import { spotterIdHash } from '@/hooks/useSpotterHash';

export const NoActiveTelemetryAlert = ({ spotterId }: { spotterId?: string | null }) => {
    return (
        <InlineAlert
            severity="warning"
            actionButton={
                <InlineAlertPrimaryButton href={`/telemetry#${spotterId ? spotterIdHash(spotterId) : ''}`}>
                    Manage telemetry
                </InlineAlertPrimaryButton>
            }
        >
            <InlineAlertTitle>No telemetry is enabled for this Spotter.</InlineAlertTitle>
            <InlineAlertBody>
                To change your Spotter&#39;s mode, you will need to have at least one telemetry line enabled.
            </InlineAlertBody>
        </InlineAlert>
    );
};
